import {getOne, createOne, updateOne, deleteOne, getAll, getAllBy} from "./Api";

const MODULE = 'comment';

export function getComment(id) {
	return getOne(MODULE, id);
}

export function getComments(maxResults, searchQuery) {
	return getAll(MODULE, maxResults, searchQuery);
}

export function getCommentsByProperty(property, value) {
	return getAllBy(MODULE, property, value);
}

export function createComment(data) {
	return createOne(MODULE, data);
}

export function updateComment(data) {
	return updateOne(MODULE, data);
}

export function deleteComment(id) {
	return deleteOne(MODULE, id);
}
